import {PropertiesState} from '../reducers/properties.reducer';

export const grundfos = {
  all: <PropertiesState>{
    po_subnavStrategy: 'tabNav',
    headerInfoLinkLabelID: 'headerInformation'
  }
};
